<template>
  <div class="site-filter" :class="{ 'hight-light': highLight }">
    <!-- <div class="site-filter-row">一共查询到 {{ totalRecord }} 条记录</div> -->
    <div class="site-filter-row">
      <el-input
        v-model="queryObj.name"
        placeholder="请输入企业名称"
        class="search-input-box"
        clearable
      >
        <!--        suffix-icon="el-icon-search icon-search"-->
      </el-input>
    </div>
    <div class="site-filter-row">
      <el-select
        v-model="queryObj.jurisdiction"
        filterable
        placeholder="请选择辖区"
        clearable
        style="width: 100%"
      >
        <el-option
          v-for="item in jurisdiction"
          :key="`jurisdiction-${item.Key}`"
          :label="item.Value"
          :value="item.Key"
        />
      </el-select>
    </div>
    <div class="site-filter-row">
      <el-date-picker
        v-model="queryObj.date"
        style="width: 100%"
        type="monthrange"
        value-format="yyyy-MM"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
    </div>

    <div class="site-filter-row">
      <div class="btn-search" @click="doFilter()">搜索</div>
    </div>
  </div>
</template>

<script >
import _ from "lodash";
export default {
  name: "dangerTypeFilter",
  props: {
    highLight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value1: undefined,
      queryObj: {
        name: undefined,
        jurisdiction: undefined,
        date: [],
      },
      // 是否收起
      collapsed: false,
      jurisdiction: [],
      manageCategory: [],
    };
  },
  computed: {},
  watch: {
    // queryObj: {
    //   handler(val) {
    //     this.doFilter(val)
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  mounted() {
    this.getParams();
    this.doFilter();
    // m2fwU2X().then(data => {
    //   console.log(data)
    // })
  },
  beforeCreate() {
    // addEvent(window, 'click', mouseClick)
  },
  beforeDestroy() {
    // removeEvent(window, 'click', mouseClick)
  },
  methods: {
    getParams() {
      let url = this.$api.map.getParams;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          let { jurisdiction, manageCategory } = res.data.data;
          this.manageCategory = manageCategory;
          this.jurisdiction = jurisdiction;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    // 条件筛选
    // doFilter: _.debounce(function (params) {
    //   this.$emit('change', params)
    // }, 500),
    doFilter() {
      this.$emit("change", this.queryObj);
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-search {
  width: 100%;
  text-align: center;
  border: 1px solid #409eff;
  border-radius: 4px;
  padding: 9px 20px;
  background-color: #40a0ff11;
  cursor: pointer;
  color: #c0c4cc;
  letter-spacing: 4px;
}
.area-popper {
  background: rgba(13, 25, 36, 0.84);
  border: 1px solid rgba(13, 25, 36, 0.84);

  .el-select-dropdown__item {
    color: #ffffff;

    &.hover {
      background-color: transparent !important;
    }

    &.selected {
      color: #409eff;
      font-weight: 700;
    }
  }

  &.el-popper[x-placement^="top"] {
    .popper__arrow {
      border-bottom-color: rgba(13, 25, 36, 0.84);
    }

    .popper__arrow::after {
      border-top-color: rgba(13, 25, 36, 0.84);
      border-bottom-width: 0;
    }
  }

  &.el-popper[x-placement^="bottom"] {
    .popper__arrow {
      border-bottom-color: rgba(13, 25, 36, 0.84);
    }

    .popper__arrow::after {
      border-top-width: 0;
      border-bottom-color: rgba(13, 25, 36, 0.84);
    }
  }

  &.light-popper {
    background-color: #6b927c;
    border: 1px solid #1d4c47;

    .el-select-dropdown__item {
      color: #ffffff;

      &.hover {
        background-color: #a9bba782 !important;
      }

      &.selected {
        color: #409eff;
        font-weight: 700;
      }
    }

    &.el-popper[x-placement^="top"] {
      .popper__arrow {
        border-bottom-color: #6b927c;
      }

      .popper__arrow::after {
        border-top-color: #6b927c;
        border-bottom-width: 0;
      }
    }

    &.el-popper[x-placement^="bottom"] {
      .popper__arrow {
        border-bottom-color: #6b927c;
      }

      .popper__arrow::after {
        border-top-width: 0;
        border-bottom-color: #6b927c;
      }
    }
  }

  .el-cascader-node:not(.is-disabled):focus,
  .el-cascader-node:not(.is-disabled):hover {
    background-color: #a9bba782 !important;
  }

  .el-cascader-menu {
    color: #ffffff;
  }

  .el-cascader-node {
    color: #ffffff;

    &.is-selectable {
      color: #ffffff;
    }

    &.in-active-path {
      color: #ffffff;
    }

    &.is-active {
      color: #409eff;
    }

    &.in-checked-path {
      color: #409eff;
    }
  }
}

.site-filter {
  display: block;
  color: #fff;
  padding: 15px;

  .collapsed-panel {
    transition: height 0.3s;
  }

  .site-filter-row {
    margin: 0 0 15px 0;
    // @include clearfix;
  }

  &.hight-light {
    background-color: rgba(0, 21, 40, 0.95);
    color: #ffffff;
    border: 1px solid #409eff;
    border-radius: 5px;

    .site-filter-row {
      color: #ffffff;
    }

    ::v-deep .el-input__inner {
      border: 1px solid #409eff;
      background-color: #40a0ff11;
      color: #ffffff;
    }

    ::v-deep .el-cascader__search-input {
      background-color: transparent;
    }
  }
}
</style>
